export default __webpack_public_path__ + "static/media/erx-delivery-expired-icon.98d79bf8.svg";